module.exports = __webpack_public_path__ + "img/July.6e7b5c45.png";